import {AutomatedCommentSource, type AutomatedCommentSourceType} from '../types'
import {
  pluralizedTexts,
  ALERT_ENTITY,
  FINDING_ENTITY,
  type DismissalEntity,
} from '@github-ui/shared-dismissal/pluralized-texts'

function entityForSource(source: AutomatedCommentSourceType): DismissalEntity {
  switch (source) {
    case AutomatedCommentSource.CodeScanning:
      return ALERT_ENTITY
    default:
      return FINDING_ENTITY
  }
}

export function dialogTextsForSource(source: AutomatedCommentSourceType, delegatedDismissalEnabled: boolean) {
  if (source === AutomatedCommentSource.LicenseCompliance) {
    return {
      title: 'Request to close license alert',
      subtitle:
        'An authorized approver needs to close this alert. Submitting this request will send a notification to all approvers for their review.',
      submitButtonLabel: 'Submit request',
    }
  }

  const entity = entityForSource(source)
  const {title, subtitle, submitButtonLabel, delegatedAlertDismissal} = pluralizedTexts(entity, 1)

  if (delegatedDismissalEnabled) {
    return {
      title: delegatedAlertDismissal.title,
      subtitle: delegatedAlertDismissal.subtitle,
      submitButtonLabel: delegatedAlertDismissal.submitButtonLabel,
    }
  }

  return {title, subtitle, submitButtonLabel}
}
